/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import UserQueryResult from './UserQueryResult';

/**
 * The UserOutputCmsUser model module.
 * @module model/UserOutputCmsUser
 * @version 1.0
 */
class UserOutputCmsUser {
    /**
     * Constructs a new <code>UserOutputCmsUser</code>.
     * @alias module:model/UserOutputCmsUser
     */
    constructor() { 
        
        UserOutputCmsUser.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>UserOutputCmsUser</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UserOutputCmsUser} obj Optional instance to populate.
     * @return {module:model/UserOutputCmsUser} The populated <code>UserOutputCmsUser</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UserOutputCmsUser();

            if (data.hasOwnProperty('user')) {
                obj['user'] = UserQueryResult.constructFromObject(data['user']);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/UserQueryResult} user
 */
UserOutputCmsUser.prototype['user'] = undefined;






export default UserOutputCmsUser;

